<template>
    <div class="quantity-change-container">
        <div class='quantity-container' v-if='this.product.total_stock != 0' >
            <input class='quantity-text-box' type="text" id="quantity" name="quantity" v-model='quantity' @blur='blurQuantity'>
            <div class='quantity-buttons-container'>
                <div @click='incrementQuantity' class='change-quantity-button no-highlight'>+</div>
                <div @click='decrementQuantity' class='change-quantity-button no-highlight'>-</div>
            </div>
        </div>
        <div v-if='this.product.total_stock != 0' class='add-to-cart-button'>
            <Button class='button' :text='button_text' :theme='theme' @click='addToCart'/>
            <Tooltip class='successfully-added-to-bag-container' :tooltip_queue='tooltip_queue'/>
        </div>
    </div>
</template>
<script>
import {checkAuth, fireOmetriaBasketEvent} from "@/global/modules/functions.js";
import Button from '@/ecom/components/buttons/Button.vue'
import Tooltip from '@/ecom/components/popups/Tooltip.vue';

export default {
    components: {Tooltip, Button},
    props: ['product', 'button_text', 'unit_type', 'theme'],
    emits: ['updatedCartListener', 'addToCartListener'],
    data(){
        return{
            quantity: 1,
            stock: {},
            tooltip_queue: []
        }
    },
    methods:{
        async addToCart(){
            let response = await fetch(`/api/cart/update`, {
                method: 'POST',
                headers: {'Content-Type': 'application/json'},
                body: JSON.stringify({
                   product: this.product,
                   quantity: this.quantity,
                   type: 'increment_quantity',
                   unit_type : this.unit_type
                }),    
            });

            let results = await checkAuth(response);
            
            if (response.status === 200){
                if(!results.stock.in_stock) {
                    let out_of_stock_message = '';
                    if(results.stock.left_in_stock > 0) {
                        out_of_stock_message = 'There are only ' + results.stock.left_in_stock  + ' of this item left in stock';
                    } else if(results.stock.left_in_stock == 0){
                        out_of_stock_message = 'This item is out of stock';
                    }
                    this.tooltip_queue.push({text: out_of_stock_message});
                } else {
                    this.quantity = 1;
                    this.tooltip_queue.push({text: 'Added to bag!'});
                    this.stock = results.stock;
                    this.$emit('updatedCartListener');
                    this.$emit('addToCartListener', this.product, this.quantity);
                    fireOmetriaBasketEvent(results.cart, results.basket_id);
                }
               
            }
        },
        blurQuantity(){
            if(isNaN(this.quantity) || this.quantity == ''){
                this.quantity = 1;
            }
        },
        incrementQuantity(){
            this.quantity++;
        },
        decrementQuantity(){
            if(this.quantity > 1){
                this.quantity--;
            }
        }
    }
}
</script>
<style lang="scss" scoped>
.quantity-change-container{
    display: flex;
    gap: 12px;
}
.quantity-text-box{
    width: 40px;
    height: 38px;
    text-align: center;
    border-top: solid 1px #dee2e6;
    border-left: none;
    border-right: none;
    border: 1px solid #dee2e6;
    outline: none;
}

.add-to-cart-button{
   // width: 100px;
    position: relative;
    font-size: 0.6rem;
}

.quantity-container{
    display: flex;
}

.change-quantity-button{
    border: 1px solid #dee2e6;
    height: 19px;
    width: 19px; 
    cursor: pointer;
    text-align: center;
}

.successfully-added-to-bag-container{
    width: 200px;
    margin-left: -70px;
    z-index: 2;
    text-align: center;
    border-radius: 8px;
    font-size: 0.8rem;
    @media(max-width: 768px){
        width: 105px;
        margin-left: -25px;
    }
}
.button{
    width: 135px;
    font-size: 0.72rem;
}
</style>